<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Accessories</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (emergencyHeaterSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Emergency Heater:</span>
              <select class="halfWidthInputField" #emergencyHeaterInput
                [class.invalidConfigurationSelection]="isInvalidSelection(emergencyHeaterSelection.Name)"
                (change)="selectionChanged(emergencyHeaterSelection, emergencyHeaterInput.value)"
                [value]="emergencyHeaterSelection.Value.toString()">
                @for (allowable of emergencyHeaterSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="emergencyHeaterSelection.Value && emergencyHeaterSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (thermostatSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Thermostat:</span>
              <select class="halfWidthInputField" #thermostatInput
                [class.invalidConfigurationSelection]="isInvalidSelection(thermostatSelection.Name)"
                (change)="selectionChanged(thermostatSelection, thermostatInput.value)"
                [value]="thermostatSelection.Value.toString()">
                @for (allowable of thermostatSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="thermostatSelection.Value && thermostatSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (wallPlateSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(wallPlateSelection.Name)"
              for="wallPlateInput" class="halfWidthInputLabel">Wall Plate:</label>
              <input type="checkbox" class="checkboxInput" id="wallPlateInput"
                #outdoorTempSensorInput [checked]="'true' === wallPlateSelection.Value"
                (change)="selectionChanged(wallPlateSelection, outdoorTempSensorInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (climazonePanelSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(climazonePanelSelection.Name)"
              for="climazonePanelInput" class="halfWidthInputLabel">ClimaZone Zoning Panel:</label>
              <input type="checkbox" class="checkboxInput" id="climazonePanelInput"
                #outdoorTempSensorInput [checked]="'true' === climazonePanelSelection.Value"
                (change)="selectionChanged(climazonePanelSelection, outdoorTempSensorInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (smartTankSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">iGate 2 Smart Tank:</span>
              <select class="halfWidthInputField" #smartTankInput
                [class.invalidConfigurationSelection]="isInvalidSelection(smartTankSelection.Name)"
                (change)="selectionChanged(smartTankSelection, smartTankInput.value)"
                [value]="smartTankSelection.Value.toString()">
                @for (allowable of smartTankSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="smartTankSelection.Value && smartTankSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (outdoorTemperatureSensorSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(outdoorTemperatureSensorSelection.Name)"
              for="outdoorTempSensorInput" class="halfWidthInputLabel">Outdoor Temperature Sensor:</label>
              <input type="checkbox" class="checkboxInput" id="outdoorTempSensorInput"
                #outdoorTempSensorInput [checked]="'true' === outdoorTemperatureSensorSelection.Value"
                (change)="selectionChanged(outdoorTemperatureSensorSelection, outdoorTempSensorInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (pcServiceToolSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(pcServiceToolSelection.Name)"
              for="pcServiceToolInput" class="halfWidthInputLabel">PC Service Tool:</label>
              <input type="checkbox" class="checkboxInput" id="pcServiceToolInput"
                #antiScaldValveInput [checked]="'true' === pcServiceToolSelection.Value"
                (change)="selectionChanged(pcServiceToolSelection, antiScaldValveInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (secondaryDrainPanSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(secondaryDrainPanSelection.Name)"
              for="secondaryDrainPanInput" class="halfWidthInputLabel">Secondary Drain Pan:</label>
              <input type="checkbox" class="checkboxInput" id="secondaryDrainPanInput"
                #compressorSoftStartKitInput [checked]="'true' === secondaryDrainPanSelection.Value"
                (change)="selectionChanged(secondaryDrainPanSelection, compressorSoftStartKitInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (unitPadSelection) {
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Unit Pad:</span>
              <select class="halfWidthInputField" #unitPadInput
                [class.invalidConfigurationSelection]="isInvalidSelection(unitPadSelection.Name)"
                (change)="selectionChanged(unitPadSelection, unitPadInput.value)"
                [value]="unitPadSelection.Value.toString()">
                @for (allowable of unitPadSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="unitPadSelection.Value && unitPadSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (packagedUnitStandSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(packagedUnitStandSelection.Name)"
              for="packagedUnitStandInput" class="halfWidthInputLabel">Packaged Unit Stand:</label>
              <input type="checkbox" class="checkboxInput" id="packagedUnitStandInput"
                #packagedUnitStandInput [checked]="'true' === packagedUnitStandSelection.Value"
                (change)="selectionChanged(packagedUnitStandSelection, packagedUnitStandInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (extendedWarrantySelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(extendedWarrantySelection.Name)"
              for="extendedWarrantyInput" class="halfWidthInputLabel">Extended Warranty:</label>
              <input type="checkbox" class="checkboxInput" id="extendedWarrantyInput"
                #extendedWarrantyInput [checked]="'true' === extendedWarrantySelection.Value"
                (change)="selectionChanged(extendedWarrantySelection, extendedWarrantyInput.checked.toString())">
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
